import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    filterIcon: {
        '&.MuiButtonBase-root': {
            marginRight: '8px',
        },
    },
    sortingIcon: {
        '&.MuiButtonBase-root': {
            marginRight: '8px',
        },
    },
    container: {
        paddingRight: '16px',
        paddingLeft: '16px',
    },
}));
